import { ofType } from "redux-observable";
import { switchMap } from "rxjs/operators";
import { TypeActionCoopInfo } from "../actionCoop";
import { pathSelectCoopMenuTab } from "../path/pathSelectCoopMenuTab";
export var epicCoopMenuTabGoTo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.TabGoTo), switchMap(function (action) { return pathSelectCoopMenuTab(action, state$, deps); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopMenuTabGoTo.ts
// module id = 1815
// module chunks = 3